module.exports = __webpack_public_path__ + "img/space-error.1ca50ddc.png";